module.exports = __webpack_public_path__ + "img/wj03.51e61d08.png";